import { ZoomIn, ZoomOut } from 'lucide-react';

import '../venue-booking-content.css';

const STEP = 0.25;

export interface PhotoZoomControlProps {
  zoom: number;
  maxZoom: number;
  /** False when the photo is too small to zoom into. */
  enabled: boolean;
  phone: boolean;
  onChange: (zoom: number) => void;
}

/** A slider with minus and plus buttons for zooming the photo inside the crop box. */
export function PhotoZoomControl({
  zoom,
  maxZoom,
  enabled,
  phone,
  onChange,
}: PhotoZoomControlProps) {
  const buttonSize = phone ? 44 : 26;
  const buttonStyle = {
    width: buttonSize,
    height: buttonSize,
    padding: 0,
    justifyContent: 'center',
    color: 'inherit',
  } as const;
  return (
    <div
      className={phone ? 'vbc-phone' : undefined}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 9,
        color: enabled ? 'var(--nb-muted)' : 'var(--nb-faint)',
      }}
    >
      <button
        type="button"
        className="nb-btn nb-btn-ghost"
        aria-label="Zoom out"
        disabled={!enabled || zoom <= 1}
        onClick={() => onChange(Math.max(1, +(zoom - STEP).toFixed(2)))}
        style={buttonStyle}
      >
        <ZoomOut size={14} aria-hidden="true" />
      </button>
      <input
        type="range"
        className="vbc-zoom"
        aria-label="Zoom"
        min={1}
        max={enabled ? maxZoom : 1}
        step={0.05}
        value={zoom}
        disabled={!enabled}
        onChange={(e) => onChange(Number(e.target.value))}
      />
      <button
        type="button"
        className="nb-btn nb-btn-ghost"
        aria-label="Zoom in"
        disabled={!enabled || zoom >= maxZoom}
        onClick={() => onChange(Math.min(maxZoom, +(zoom + STEP).toFixed(2)))}
        style={buttonStyle}
      >
        <ZoomIn size={14} aria-hidden="true" />
      </button>
    </div>
  );
}
